import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=10104a8a&scoped=true"
import script from "./Entities.vue?vue&type=script&lang=js"
export * from "./Entities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10104a8a",
  null
  
)

export default component.exports